<template>
  <b-modal
    v-model="showModal"
    :title="customerId > -1 ? `Ügyfél szerkesztése` : 'Új ügyfél létrehozása'"
    ok-title="Mentés"
    ok-variant="success"
    cancel-title="Mégsem"
    size="lg"
    :ok-disabled="!isValid || loading"
    @ok="save"
  >
    <loading v-model="loading" :height="500">
      <customer-editor v-model="customer" :errors="errors" @validated="$e => isValid = $e"></customer-editor>
    </loading>
  </b-modal>
</template>
<script>
import CustomerEditor from './CustomerEditor'
import Loading from '../common/LoadingPlaceholder'
import customer from './_customer'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

export default {
  mixins: [
    ErrorHandler(true, false)
  ],
  components: {
    'customer-editor': CustomerEditor,
    'loading': Loading
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    customerId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      customer,
      errors: {},
      isValid: true,
      loading: true,
    }
  },
  computed: {
  },
  watch: {
    showModal: function(show) {
      if(show) {
        this.reset()
      }

      if(show && this.customerId > -1) {
        this.$http.get(this.$url('api.customers.show', this.customerId))
          .then(({data}) => {
            if(data.customer) {
              _.forEach(data.customer, (value, key) => {
                this.customer[key] = value
              })
            }

            this.loading = false
          })
      } else {
        this.loading = false
      }

      this.$emit('update:show', show)
    },
    show: function(show) {
      this.showModal = show
    }
  },
  mounted() {
    this.showModal = this.show
  },
  methods: {
    reset() {
      this.loading = true
      this.errors = {}
      this.customer = _.assign({}, customer)
    },
    save(modal) {
      modal.preventDefault()

      if(this.customer.id > -1) {
        this.$http.patch(this.$url('api.customers.update', this.customer.id), this.customer)
          .then(({data}) => {
            if(data.customer) {
              this.$emit('change', {id: data.customer.id, name: data.customer.name})
            }
            this.showModal = false
          })
          .catch((err) => {
            this.errors = this.handleErrors(err)
          })
      } else {
        this.$http.post(this.$url('api.customers.store'), this.customer)
          .then(({data}) => {
            if(data.customer) {
              this.$emit('add', {id: data.customer.id, name: data.customer.name})
            }
            this.showModal = false
          })
          .catch(this.handleErrors)
      }
    }
  }
}
</script>